import type { Theme } from '@mui/material/styles'
import { LeadStatus } from '@otw/models/leads/lead'
import { leadStatusTone } from 'components/StatusChip'
import { LIGHT_STATUS } from 'core/theme.tokens'

export const getStatusLabel = (status: LeadStatus | null | undefined): string => {
  if (!status) return 'New'

  switch (status) {
    case 'new':
      return 'New'
    case 'inProgress':
      return 'In Progress'
    case 'waitingFinance':
      return 'Waiting Finance'
    case 'closed':
      return 'Closed'
    case 'lost':
      return 'Lost'
    default:
      return status
  }
}

export const getBorderColor = (
  status: LeadStatus | null | undefined,
  theme?: Theme,
): string => {
  const tone = leadStatusTone(status || 'new')
  return (theme?.custom.status ?? LIGHT_STATUS)[tone].fg
}
